import { ApplicationState } from "../../../store/index";
import { connect } from "react-redux";
import { SaveConfirmedProps, SaveConfirmed } from './saveConfirmed';
import { actionCreator } from '../../../store/uiproperties/UIState';
import _ from "underscore";


const mapStateToProps = (state: ApplicationState): SaveConfirmedProps => {

    return {
        savedSuccess: state.uiProperties.saveSucceded
    }
};

const mapDispatchToProps = () => dispatch => {
    return ({
        close: () => {
            dispatch(actionCreator.saveSuceeded(false))
        }
    })
}

export const ConnectedSaveConfirmed = connect<SaveConfirmedProps>(mapStateToProps, mapDispatchToProps)(SaveConfirmed);